function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M21 10.826c.015 5.557-4.443 10.092-10 10.173a9.85 9.85 0 01-10-9.824C.985 5.618 5.443 1.083 11 1.001a9.852 9.852 0 0110 9.825zm-10 1.478V6.217m-.002 9.131h.004",
  stroke: "#000",
  strokeWidth: 1.2,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22
  }, props), _ref);
}

export default SvgAlert;